import PropTypes from 'prop-types';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import Apple from './assets/Apple.svg';
import Google from './assets/Google.svg';

const propTypes = {
	children: PropTypes.node,
	dataTestId: PropTypes.string,
	href: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	size: PropTypes.oneOf(['large', 'medium', 'small']),
	variant: PropTypes.oneOf(['google', 'apple']),
};
const defaultProps = {
	children: null,
	dataTestId: null,
	size: 'large',
	variant: 'google',
};

const sizeConfig = {
	medium: '40px',
	small: '32px',
};

const StyledButtonDownload = styled.a`
	display: inline-flex;
	position: relative;

	& img {
		display: flex;
		height: ${(props) => (sizeConfig[props.size] ? sizeConfig[props.size] : `48px`)};
	}

	&:focus,
	&:active {
		border-radius: 5px;
		outline: var(--spacing-global-space1) solid var(--color-functional-focus);
	}

	/* invisible pseudo element to make the tappable area on buttons at least 44x44px */
	&:after {
		content: '';
		display: block;
		min-height: 44px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		min-width: 44px;
		width: 100%;
	}
`;

function ButtonDownload({ children, dataTestId, href, alt, variant, ...other }) {
	return (
		<StyledButtonDownload
			className="fuse-download-button"
			data-testid={dataTestId}
			href={href}
			aria-label={`${alt} link`}
			{...other}
		>
			<img
				className="fuse-download-button__image"
				alt={alt}
				src={`data:image/svg+xml;utf8,${encodeURIComponent(
					renderToStaticMarkup(variant === 'apple' ? <Apple /> : <Google />),
				)}`}
			/>
		</StyledButtonDownload>
	);
}

ButtonDownload.propTypes = propTypes;
ButtonDownload.defaultProps = defaultProps;

export default ButtonDownload;
